import Axios from 'axios'
import requestPrefix from '../requestPrefix'
import { localDev } from '../../utils/constant'
import carRecord1 from './car-record'
import { page as carVisitorPage } from './car-visitor'
const prefix = localDev ? '' : requestPrefix.centerUrl

/**
 * 查询控制台应用
 * @returns {AxiosPromise}
 */
export function listApp(data) {
  return Axios({
    url: '/system/menu/getRouters',
    method: 'get',
    params: data
  })
}
// 查询公告列表
export function listNotice(query){
  return Axios({
    url: '/system/notice/list',
    method: 'get',
    params: query
  });
}
// 新闻列表
export function pagepressRelecase(data){
  return Axios({
      url: `/project/pressRelecase/page`,
      method: 'get',
      params: data
  });
};

export function getAppMenus(data) {
  return Axios({
    url: prefix + '/sys/menu/getAppMenus',
    method: 'get',
    params: data
  })
}
export function getAllAppMenus(data) {
  return Axios({
    url: '/system/menu/getRouters',
    method: 'get',
    params: data
  })
}

export function carRecord() {
  return carRecord1
}
export function carVisitor(data) {
  return carVisitorPage(data)
}
// export default {carRecord}



// WEBPACK FOOTER //
// ./src/api/manage/index.js